var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_748",
    "data-name": "Group 748",
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.492,
    height: 60.547,
    viewBox: "0 0 191.492 60.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M177.067,0H14.433c-.556,0-1.1,0-1.657,0-.463,0-.923.012-1.391.02A19.913,19.913,0,0,0,8.351.289a10.172,10.172,0,0,0-2.877.949A9.754,9.754,0,0,0,3.024,3.023,9.513,9.513,0,0,0,1.24,5.476,10.028,10.028,0,0,0,.294,8.357a19.8,19.8,0,0,0-.271,3.03c-.014.465-.015.931-.023,1.394V47.77c.008.469.009.925.023,1.394a19.762,19.762,0,0,0,.271,3.03,10,10,0,0,0,.946,2.884,9.435,9.435,0,0,0,1.785,2.443,9.535,9.535,0,0,0,2.449,1.785,10.134,10.134,0,0,0,2.877.954,20.11,20.11,0,0,0,3.033.268c.468.011.928.017,1.391.017.554,0,1.1,0,1.657,0H177.067c.545,0,1.1,0,1.641,0,.462,0,.934-.006,1.4-.017a19.842,19.842,0,0,0,3.027-.268,10.264,10.264,0,0,0,2.888-.954,9.536,9.536,0,0,0,2.449-1.785,9.7,9.7,0,0,0,1.788-2.443,9.983,9.983,0,0,0,.937-2.884,20.566,20.566,0,0,0,.282-3.03c.006-.469.006-.925.006-1.394.012-.551.012-1.1.012-1.656V14.434c0-.554,0-1.1-.012-1.653,0-.463,0-.929-.006-1.394a20.6,20.6,0,0,0-.282-3.03,10.009,10.009,0,0,0-.937-2.881,9.778,9.778,0,0,0-4.237-4.238A10.3,10.3,0,0,0,183.13.289,19.651,19.651,0,0,0,180.1.023c-.462-.008-.934-.017-1.4-.02-.543,0-1.1,0-1.641,0Z",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M12.335,58.773c-.462,0-.911-.006-1.368-.017a19.1,19.1,0,0,1-2.831-.247,8.877,8.877,0,0,1-2.507-.829,8.134,8.134,0,0,1-2.115-1.538,8.067,8.067,0,0,1-1.545-2.115,8.706,8.706,0,0,1-.822-2.508A18.751,18.751,0,0,1,.9,48.681C.885,48.362.873,47.3.873,47.3V12.332S.887,11.286.9,10.979a18.693,18.693,0,0,1,.25-2.834,8.666,8.666,0,0,1,.823-2.516A8.08,8.08,0,0,1,3.505,3.513,8.427,8.427,0,0,1,5.627,1.965a8.807,8.807,0,0,1,2.5-.823,19.148,19.148,0,0,1,2.84-.248L12.335.875H178.251l1.382.02a18.726,18.726,0,0,1,2.814.245,9.042,9.042,0,0,1,2.529.829,8.487,8.487,0,0,1,3.656,3.663,8.732,8.732,0,0,1,.81,2.5,19.824,19.824,0,0,1,.263,2.856c0,.428,0,.89,0,1.347.012.568.012,1.108.012,1.653v31.68c0,.549,0,1.087-.012,1.627,0,.492,0,.943-.006,1.408a19.427,19.427,0,0,1-.259,2.8,8.705,8.705,0,0,1-.817,2.528,8.293,8.293,0,0,1-1.538,2.1,8.173,8.173,0,0,1-2.118,1.547,8.843,8.843,0,0,1-2.525.833,18.9,18.9,0,0,1-2.829.247c-.444.011-.908.017-1.359.017l-1.641,0Z",
    transform: "translate(0.448 0.449)"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(15.098 12.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(0 1.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M32.373,23.551a7.489,7.489,0,0,1,3.566-6.285A7.666,7.666,0,0,0,29.9,14c-2.541-.266-5.006,1.521-6.3,1.521-1.32,0-3.313-1.5-5.461-1.45A8.042,8.042,0,0,0,11.365,18.2c-2.927,5.069-.745,12.518,2.06,16.616,1.4,2.006,3.042,4.246,5.189,4.167,2.1-.088,2.884-1.34,5.417-1.34,2.511,0,3.247,1.34,5.436,1.29,2.252-.038,3.672-2.016,5.027-4.042a16.583,16.583,0,0,0,2.3-4.68A7.237,7.237,0,0,1,32.373,23.551Z",
    transform: "translate(-9.974 -6.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M23.716,14A7.378,7.378,0,0,0,25.4,8.72a7.507,7.507,0,0,0-4.856,2.513,7.02,7.02,0,0,0-1.732,5.087A6.206,6.206,0,0,0,23.716,14Z",
    transform: "translate(-5.452 -8.72)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(36.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M36.619,17.767V10.011H33.778V8.735h7.079v1.276H38.022v7.756Z",
    transform: "translate(-33.778 -7.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M44.836,16.292a2.769,2.769,0,0,1-2.955,1.972c-1.953,0-3.148-1.34-3.148-3.519s1.222-3.56,3.144-3.56c1.9,0,3.039,1.3,3.039,3.436v.469H40.1v.076a1.8,1.8,0,0,0,1.815,1.953,1.635,1.635,0,0,0,1.621-.826ZM40.1,14.1h3.442a1.645,1.645,0,0,0-1.677-1.766A1.742,1.742,0,0,0,40.1,14.1Zm.963-3.919,1.571-2.154h1.577l-1.759,2.154Z",
    transform: "translate(-31.233 -8.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M44.053,8.441H45.4v9.477H44.053Z",
    transform: "translate(-28.5 -7.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M52.279,16.292a2.768,2.768,0,0,1-2.953,1.972c-1.953,0-3.148-1.34-3.148-3.519s1.22-3.56,3.142-3.56c1.9,0,3.041,1.3,3.041,3.436v.469H47.547v.076a1.8,1.8,0,0,0,1.815,1.953,1.637,1.637,0,0,0,1.623-.826Zm-4.732-2.2h3.442a1.644,1.644,0,0,0-1.677-1.766A1.744,1.744,0,0,0,47.547,14.1Zm.964-3.919,1.571-2.154H51.66L49.9,10.177Z",
    transform: "translate(-27.409 -8.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M56.032,12.47a1.519,1.519,0,0,0-1.609-1.156c-1.126,0-1.815.863-1.815,2.316,0,1.477.695,2.36,1.815,2.36a1.482,1.482,0,0,0,1.609-1.122h1.309a2.669,2.669,0,0,1-2.911,2.323c-1.986,0-3.2-1.34-3.2-3.562,0-2.184,1.208-3.518,3.192-3.518a2.691,2.691,0,0,1,2.918,2.358Z",
    transform: "translate(-24.813 -6.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M56.447,8.441h1.334V12.2h.106a2.1,2.1,0,0,1,2.078-1.22,2.245,2.245,0,0,1,2.348,2.54v4.4H60.967V13.849c0-1.09-.507-1.641-1.458-1.641a1.593,1.593,0,0,0-1.717,1.729v3.981H56.447Z",
    transform: "translate(-22.134 -7.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M61.439,15.131c0-1.226.914-1.934,2.535-2.034l1.847-.106V12.4c0-.721-.475-1.126-1.4-1.126-.751,0-1.271.275-1.42.757H61.7c.138-1.17,1.24-1.921,2.785-1.921,1.709,0,2.672.851,2.672,2.29V17.06H65.865V16.1h-.106a2.294,2.294,0,0,1-2.048,1.07A2.059,2.059,0,0,1,61.439,15.131Zm4.382-.583v-.569l-1.665.106c-.938.064-1.364.383-1.364.984s.533.97,1.264.97A1.607,1.607,0,0,0,65.821,14.549Z",
    transform: "translate(-19.569 -6.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M66.61,10.238H67.9v1.044h.1a1.849,1.849,0,0,1,1.841-1.158,2.823,2.823,0,0,1,.6.056v1.327a3.668,3.668,0,0,0-.751-.082,1.6,1.6,0,0,0-1.739,1.6v4.025H66.61Z",
    transform: "translate(-16.913 -6.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M70.052,17.735h1.377c.114.495.683.814,1.589.814,1.122,0,1.785-.533,1.785-1.433V15.808h-.1a2.293,2.293,0,0,1-2.1,1.144c-1.739,0-2.815-1.344-2.815-3.386,0-2.078,1.087-3.442,2.829-3.442a2.362,2.362,0,0,1,2.14,1.2h.106V10.238h1.29V17.11c0,1.559-1.222,2.548-3.148,2.548C71.3,19.657,70.2,18.893,70.052,17.735Zm4.777-4.175c0-1.358-.7-2.228-1.848-2.228s-1.807.87-1.807,2.228.649,2.228,1.807,2.228S74.829,14.925,74.829,13.56Z",
    transform: "translate(-15.283 -6.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M81.283,15.219a2.767,2.767,0,0,1-2.953,1.972c-1.953,0-3.148-1.34-3.148-3.519s1.222-3.56,3.142-3.56c1.9,0,3.041,1.3,3.041,3.436v.469H76.551v.076a1.8,1.8,0,0,0,1.816,1.953,1.635,1.635,0,0,0,1.621-.826Zm-4.732-2.2h3.444a1.646,1.646,0,0,0-1.679-1.766A1.744,1.744,0,0,0,76.551,13.023Z",
    transform: "translate(-12.51 -6.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M80.459,10.238h1.3v1.044h.1A1.849,1.849,0,0,1,83.7,10.124a2.828,2.828,0,0,1,.6.056v1.327a3.682,3.682,0,0,0-.751-.082,1.6,1.6,0,0,0-1.741,1.6v4.025H80.459Z",
    transform: "translate(-9.799 -6.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M86.2,14.506c0-2.154,1.106-3.518,2.829-3.518a2.246,2.246,0,0,1,2.09,1.2h.1V8.441h1.346v9.477h-1.29V16.84h-.106a2.367,2.367,0,0,1-2.14,1.19C87.29,18.03,86.2,16.666,86.2,14.506Zm1.39,0c0,1.446.681,2.316,1.821,2.316s1.835-.882,1.835-2.31S90.533,12.2,89.407,12.2,87.586,13.073,87.586,14.506Z",
    transform: "translate(-6.852 -7.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M91.6,15.131c0-1.226.914-1.934,2.535-2.034l1.847-.106V12.4c0-.721-.477-1.126-1.4-1.126-.751,0-1.271.275-1.421.757h-1.3c.138-1.17,1.238-1.921,2.785-1.921,1.709,0,2.672.851,2.672,2.29V17.06H96.028V16.1h-.106a2.294,2.294,0,0,1-2.048,1.07A2.059,2.059,0,0,1,91.6,15.131Zm4.382-.583v-.569l-1.665.106c-.938.064-1.364.383-1.364.984s.531.97,1.264.97A1.607,1.607,0,0,0,95.984,14.549Z",
    transform: "translate(-4.075 -6.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M96.773,10.244h1.294v1.082h.1a2.042,2.042,0,0,1,2.034-1.214,2.217,2.217,0,0,1,2.358,2.535V17.06h-1.344V12.985c0-1.1-.477-1.641-1.471-1.641a1.564,1.564,0,0,0-1.627,1.727V17.06H96.773Z",
    transform: "translate(-1.419 -6.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M104.577,10.112c1.532,0,2.534.713,2.666,1.915h-1.29c-.124-.5-.613-.82-1.376-.82s-1.321.357-1.321.889c0,.407.344.665,1.082.834l1.134.262c1.3.3,1.9.858,1.9,1.86,0,1.282-1.2,2.14-2.823,2.14s-2.678-.733-2.8-1.941H103.1a1.383,1.383,0,0,0,1.483.851c.837,0,1.433-.375,1.433-.92,0-.407-.319-.669-1-.833l-1.188-.275c-1.3-.307-1.9-.889-1.9-1.9C101.929,10.963,103.036,10.112,104.577,10.112Z",
    transform: "translate(1.139 -6.95)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(53.278 27.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M35.2,18.067h2.815v18.8H35.2Z",
    transform: "translate(-35.198 -17.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M39.3,24.945l1.536-6.878H43.57l-1.862,6.878Z",
    transform: "translate(-33.092 -17.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M53.191,31.784H46.025L44.3,36.864H41.271l6.786-18.8H51.21L58,36.864H54.909Zm-6.424-2.345h5.679l-2.8-8.247h-.079Z",
    transform: "translate(-32.078 -17.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M66.384,28.334c0,4.258-2.28,6.995-5.719,6.995a4.646,4.646,0,0,1-4.312-2.4h-.065v6.787H53.475V21.48H56.2v2.28h.053a4.859,4.859,0,0,1,4.362-2.423C64.09,21.336,66.384,24.086,66.384,28.334Zm-2.891,0c0-2.776-1.433-4.6-3.622-4.6-2.149,0-3.595,1.863-3.595,4.6,0,2.761,1.446,4.611,3.595,4.611C62.059,32.944,63.493,31.134,63.493,28.334Z",
    transform: "translate(-25.81 -16.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M76.348,28.334c0,4.258-2.28,6.995-5.719,6.995a4.648,4.648,0,0,1-4.312-2.4h-.065v6.787H63.439V21.48h2.723v2.28h.051a4.861,4.861,0,0,1,4.364-2.423C74.056,21.336,76.348,24.086,76.348,28.334Zm-2.891,0c0-2.776-1.433-4.6-3.621-4.6-2.149,0-3.595,1.863-3.595,4.6,0,2.761,1.446,4.611,3.595,4.611C72.023,32.944,73.456,31.134,73.456,28.334Z",
    transform: "translate(-20.691 -16.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M79.53,31.733c.209,1.865,2.019,3.088,4.494,3.088,2.37,0,4.076-1.223,4.076-2.9,0-1.458-1.028-2.333-3.465-2.93L82.2,28.4c-3.451-.834-5.054-2.448-5.054-5.068,0-3.242,2.826-5.47,6.84-5.47,3.972,0,6.693,2.228,6.786,5.47h-2.84c-.17-1.875-1.721-3.008-3.987-3.008s-3.816,1.146-3.816,2.812c0,1.329.99,2.112,3.413,2.709l2.071.509c3.857.913,5.458,2.463,5.458,5.212,0,3.516-2.8,5.719-7.257,5.719-4.169,0-6.983-2.151-7.164-5.551Z",
    transform: "translate(-13.905 -17.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M91.825,19.289v3.242h2.607v2.228H91.825v7.556c0,1.173.522,1.72,1.668,1.72a8.63,8.63,0,0,0,.925-.065v2.215a7.694,7.694,0,0,1-1.562.13c-2.775,0-3.857-1.041-3.857-3.7V24.759H87V22.531H89V19.289Z",
    transform: "translate(-8.586 -17.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M92.907,28.342c0-4.312,2.538-7.022,6.5-7.022s6.5,2.709,6.5,7.022-2.516,7.022-6.5,7.022S92.907,32.665,92.907,28.342Zm10.134,0c0-2.959-1.355-4.7-3.634-4.7s-3.636,1.759-3.636,4.7c0,2.97,1.356,4.7,3.636,4.7S103.041,31.312,103.041,28.342Z",
    transform: "translate(-5.554 -16.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M103.028,21.48h2.682v2.333h.065a3.27,3.27,0,0,1,3.3-2.476,4.35,4.35,0,0,1,.964.106v2.631a3.922,3.922,0,0,0-1.264-.17,2.834,2.834,0,0,0-2.932,3.153v8.128h-2.812Z",
    transform: "translate(-0.355 -16.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M120.421,31.168c-.378,2.488-2.8,4.2-5.9,4.2-3.987,0-6.462-2.672-6.462-6.957s2.488-7.087,6.344-7.087c3.79,0,6.176,2.605,6.176,6.76v.964H110.9v.17a3.57,3.57,0,0,0,3.687,3.883,3.1,3.1,0,0,0,3.164-1.928Zm-9.509-4.09h6.851A3.3,3.3,0,0,0,114.4,23.6,3.469,3.469,0,0,0,110.912,27.078Z",
    transform: "translate(2.229 -16.083)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleFr);
export default __webpack_public_path__ + "static/media/apple-fr.fa068cbc4bfc827194fc4ee067f2c1ee.svg";
export { ForwardRef as ReactComponent };